import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import Media from "src/components/Media"
import TextLockup from "src/components/TextLockup"
import { typography, mq, globals } from "src/styles"

const Wrapper = styled(Section)`
  position: relative;
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const SectionIllo = styled.div`
  ${mq.smallAndBelow} {
    display: none;
  }
`

const IntroText = styled(TextLockup)`
  ${globals.verticalSpacing("padding-bottom", 0.75)}
  h1, h2, h3, h4, h5, h6, p {
    margin-left: auto;
    margin-right: auto;
  }
  h1,
  h2 {
    max-width: 12em;
  }
  h3 {
    max-width: 18em;
  }
  h4,
  h5 {
    max-width: 24em;
  }
  h6 {
    max-width: 16em;
  }
  p {
    max-width: 32em;
    color: var(--light-text-color);
    strong {
      color: var(--text-color);
    }
  }
`

const ItemBorder = styled.div`
  width: 2px;
  margin-top: 14px;
  margin-bottom: 1px;
  background: var(--timeline-line-color);
  background: var(--hr-color);
  position: absolute;
  top: 0.6em;
  bottom: -0.6em;
  left: 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
`

const ItemDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--timeline-line-color);
  background: var(--hr-color);
  position: absolute;
  left: -7px;
  top: 0.5em;
  clip-path: circle(50% at 50% 50%);
`

const HighlightItem = styled.div`
  position: fixed;
  width: 100%;
  height: 50%;
  background: var(--main-color);
  top: 0;
  left: 0;
`

const TimelineItem = styled.div`
  padding-top: 1px;
  padding-left: 24px;
  position: relative;
  margin-left: 8px;
  ${({ highlight }) =>
    highlight
      ? `
    h5, p {
      color: transparent;
    }
  `
      : ""}
  h5 {
    ${typography.articleTitle}
    margin: 0 0 .3em;
    max-width: 16em;
    position: relative;
    ${mq.mediumAndBelow} {
      ${typography.articleTitleSmall}
    }
    ${mq.smallAndBelow} {
      ${typography.articleTitle}
    }
  }
  p {
    margin: 0;
    max-width: 24em;
    ${mq.mediumAndBelow} {
      ${typography.bodySmall}
    }
    ${mq.smallAndBelow} {
      ${typography.body}
    }
  }
`

const Timeline = styled.div`
  text-align: left;
  position: relative;
  --timeline-line-color: var(--hr-color);
  ${TimelineItem} {
    &:not(:last-of-type) {
      p {
        padding-bottom: 3em;
      }
    }
  }
`

const MobileSteps = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  headline,
  items,
  media,
  introText,
  id,
  hideMobile,
  hideDesktop,
}) => {
  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <div style={{ position: "relative" }}>
        <Grid small="container" medium="1 [10] 1">
          <div>
            <IntroText
              alignment="center"
              eyebrow={introText?.eyebrow}
              text={introText?._rawText}
              theme={theme}
            />
          </div>
        </Grid>
        <Grid
          small="container"
          medium="2 [10] 1 [13] 2"
          large="2 [4] 1 [5] 2"
          larger="3 [3] 1 [5] 2"
        >
          <SectionIllo>
            <Media media={media} rounded />
          </SectionIllo>
          <Timeline>
            {items.map((item, index) => {
              return (
                <TimelineItem key={item._key}>
                  {index !== items.length - 1 && (
                    <ItemBorder>
                      <HighlightItem />
                    </ItemBorder>
                  )}
                  <ItemDot>
                    <HighlightItem />
                  </ItemDot>
                  <h5>{item.title}</h5>
                  <p>{item.text}</p>
                </TimelineItem>
              )
            })}
          </Timeline>
        </Grid>
      </div>
    </Wrapper>
  )
}

export default MobileSteps
